const CURRENCY_SYMBOLS_MAP = new Map<string, string>([['USD', '$']]);

export function getCurrencySymbol(currencyKey: string): string {
  return CURRENCY_SYMBOLS_MAP.get(currencyKey) ?? currencyKey;
}
